type IconSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

interface FaIconProps {
  icon: string;
  style?: 'regular' | 'brands';
  className?: string;
  title?: string;
  spin?: boolean;
  fixedWidth?: boolean;
  size?: IconSize;
}

const SIZES: Record<IconSize, string> = {
  '2xs': 'h-2.5 w-2.5',
  'xs':  'h-3 w-3',
  'sm':  'h-3.5 w-3.5',
  'md':  'h-4 w-4',
  'lg':  'h-5 w-5',
  'xl':  'h-6 w-6',
  '2xl': 'h-8 w-8',
  '3xl': 'h-12 w-12',
};

const SIZE_PX: Record<IconSize, string> = {
  '2xs': '10px',
  'xs':  '12px',
  'sm':  '14px',
  'md':  '16px',
  'lg':  '20px',
  'xl':  '24px',
  '2xl': '32px',
  '3xl': '48px',
};

const H_CLASS_TO_PX: Record<string, string> = {
  'h-2': '8px', 'h-2.5': '10px', 'h-3': '12px', 'h-3.5': '14px',
  'h-4': '16px', 'h-5': '20px', 'h-6': '24px', 'h-7': '28px',
  'h-8': '32px', 'h-9': '36px', 'h-10': '40px', 'h-12': '48px',
  'h-14': '56px', 'h-16': '64px',
};

function extractFontSize(className: string): string | undefined {
  const classes = className.split(/\s+/);
  for (const cls of classes) {
    if (H_CLASS_TO_PX[cls]) return H_CLASS_TO_PX[cls];
  }
  return undefined;
}

export default function FaIcon({
  icon,
  style = 'regular',
  className = '',
  title,
  spin = false,
  fixedWidth = false,
  size,
}: FaIconProps) {
  const stylePrefix = style === 'brands' ? 'fa-brands' : 'fa-regular';

  const sizeClasses = size ? SIZES[size] : '';
  const finalClassName = [className, sizeClasses].filter(Boolean).join(' ');

  const classes = [
    stylePrefix,
    `fa-${icon}`,
    spin ? 'fa-spin' : '',
    fixedWidth ? 'fa-fw' : '',
    finalClassName,
  ].filter(Boolean).join(' ');

  const fontSize = size ? SIZE_PX[size] : extractFontSize(className);
  const inlineStyle = fontSize ? { fontSize } : undefined;

  if (title) {
    return <i className={classes} style={inlineStyle} role="img" aria-label={title} />;
  }
  return <i className={classes} style={inlineStyle} aria-hidden="true" />;
}

export type { IconSize };
